import { Platform, StyleSheet } from 'react-native';
import FontFamily from '../../../../constants/fonts';
import { AdminColors } from '../../constants/adminColors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#EEF2F8',
  },
  pageNotification: {
    marginHorizontal: 5,
    marginTop: 6,
    marginBottom: 20,
    borderRadius: 8,
  },
  pageHeader: {
    marginBottom: 10,
  },
  summaryRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    // marginBottom: 16,
  },
  /** On iPhone, stack summary cards and Add button vertically */
  summaryRowMobile: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
  },
  /** Add button sits below summary cards on iPhone, left-aligned */
  addButtonMobile: {
    marginTop: 4,
    marginBottom: 4,
    alignSelf: 'flex-start',
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.bold,
    lineHeight: 40,
  },
  pageSubtitle: {
    fontSize: 14,
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.regular,
    marginTop: 4,
  },
  content: {
    padding: Platform.OS === 'ios' ? 12 : 25,
  },
  kfaTabBar: {
    marginBottom: 0,
    borderBottomWidth: 2,
    borderBottomColor: '#D0D9E8',
  },
  kfaTabBarContent: {
    flexDirection: 'row',
    paddingRight: 8,
  },
  kfaTab: {
    paddingRight: 18,
    paddingTop: 0,
    paddingBottom: 10,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
    marginBottom: -2,
  },
  kfaTabActive: {
    borderBottomColor: '#005CBC',
  },
  kfaTabLabel: {
    fontSize: 13,
    fontWeight: '500',
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.medium,
    lineHeight: 18,
  },
  kfaTabLabelActive: {
    color: '#005CBC',
    fontWeight: '700',
    fontFamily: FontFamily.bold,
  },
  headerContainer: {
    marginBottom: 28,
  },
  contentBox: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    padding: Platform.OS === 'ios' ? 8 : 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 6,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#2D2D2D',
    marginBottom: 12,
    fontFamily: FontFamily.bold,
  },
  description: {
    fontSize: 14,
    color: '#616161',
    lineHeight: 22,
    marginBottom: 24,
    fontFamily: FontFamily.regular,
  },
  kfaPlaceholder: {
    borderRadius: 8,
    backgroundColor: '#F5F5F5',
    padding: 32,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
  placeholderText: {
    fontSize: 14,
    color: '#999999',
    fontFamily: FontFamily.regular,
  },
});
